"use client"

import { motion } from "framer-motion"
import { Button } from "@/components/ui/button"
import { CalendarPlus } from "lucide-react"
import { trackEvent } from "@/lib/analytics"

export function CTA() {
  const openBooking = (location: string) => {
    try {
      trackEvent('book_appointment_click', { location })
    } catch {}
    if (typeof window !== 'undefined' && (window as any).openBookingModal) {
      ;(window as any).openBookingModal(location)
    }
  }

  return (
    <section className="bg-[rgb(132,137,116)] py-12 lg:py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-3xl lg:text-4xl font-normal text-white mb-8">
            Are you ready to begin your journey to better health?
          </h2>
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <Button className="w-full sm:w-auto px-8 bg-white text-gray-600 hover:bg-white/80" onClick={() => openBooking('cta_book')} aria-label="Book Appointment">
              <span className="inline-flex items-center gap-2">
                <CalendarPlus className="h-4 w-4" aria-hidden="true" />
                Book Appointment
              </span>
            </Button>
            <Button variant="outline" className="w-full sm:w-auto border2 border-white text-white" onClick={() => openBooking('cta_free_consult')} aria-label="Free 15min Phone Consult">
              <span className="inline-flex items-center gap-2">
                <CalendarPlus className="h-4 w-4" aria-hidden="true" />
                Free 15min Phone Consult 
              </span>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

